import React from 'react'

const IconDisplayHorizontal = ({ width = '48', height = '34' }) => (
  <svg
    width={`${width}px`}
    height={`${height}px`}
    viewBox={`0 0 ${width} ${height}`}
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(0.000000, -7.000000)" fill="currentColor" fillRule="nonzero">
        <path d="M32,39 L32,41 L16,41 L16,39 L32,39 Z M48,7 L48,37 L0,37 L0,7 L48,7 Z M46,9 L2,9 L2,35 L46,35 L46,9 Z" />
      </g>
    </g>
  </svg>
)

export default IconDisplayHorizontal
